import {
	GetPlayerListRequest,
	GetPlayerListResponse,
} from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPlayerList } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetPlayerList(
	payload: GetPlayerListRequest,
	props?: UseBaseQueryOptions<GetPlayerListResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetPlayerList, payload],
		queryFn: () => getPlayerList(payload),
		...props,
	})
}
